import { createGlobalStyle } from 'styled-components';

import backgroundBussulaImage from '../assets/bussula_background.svg';

export default createGlobalStyle`
*{
  margin: 0;
  padding: 0;
  outline: 0;
  box-sizing: border-box;
}

body {
  background: #EAEAEA url(${backgroundBussulaImage}) no-repeat 70% top;
  -webkit-font-smoothing: antialiased; /* Funciona somente no Chrome */
}

body,  input, button {
  font: 1rem Roboto, sans-serif;
}

#root {
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 20px;
}

button {
  cursor: pointer;
}
`;
